import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import editIcon from "../components/img/images/editIcon.png";
import {ReactComponent as Edit} from '../assets/edit.svg';
import {ReactComponent as SearchIcon} from "../assets/serch-icon.svg"
import { ReactComponent as Plus } from "../assets/p-icon.svg";
import {ReactComponent as ClIcon} from '../assets/close-icon.svg';
import {ReactComponent as SIcon} from '../assets/save-icon.svg';

const PumpsTable = ({uId}) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [showIcon, setShowIcon] = useState(true);
  const [ingredients, setIngredients] = useState([]);
  const [optionsNames ,setOptionsNames] = useState([])
  const [totalRows, setTotalRows] = useState(0);
  const [editFrom, setEditForm] = useState(false);
  const [ePumpNo, setEPumpNo] = useState("");
  const [ePumpName, setEPumpName] = useState("");
  const [ePumpCapacity, setEPumpCapacity] = useState("");
  const [ePumpLevel, setEPumpLevel] = useState("");
  const [ePumpOffset, setEPumpOffset] = useState("");
  const [newPNo, setNewPNo] = useState("")
  const [newPName, setNewPName] = useState("");
  const [newPCapacity, setNewPCapacity] = useState("");
  const [newPLevel, setNewPLevel] = useState("");
  const [newPOffset, setNewPOffset] = useState("");
  // const [newIStock, setNewIStock] = useState("");
  const [newIngred, setNewIngred] = useState("");
  const [editId, setEditId] = useState(0);
  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  const [selectedId, setSelectedId] = useState(null);
                // new task
  const [typeD, setTypeD] = useState();
  const [userD, setUserD] = useState(null);
  const [macId, setMachineId] = useState();
  const [ingAll, setIngAll] = useState([]);
  useEffect(() => {
      const handleResize = () => {
          setSmallMedia(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
      const userDataString = sessionStorage.getItem('userData');
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserD(userData);
      }
  }, []);
  useEffect(() => {
      setMachineId(userD ?.selectedMachineIds);
  }, [userD]);

  const fetchPumps = async () => {
    if (!uId) {
      console.error('userId is required');
      return;
    }
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (!userData || !userData.id) {
      throw new Error('User ID not found in session storage');
      }
      const userId = userData.id;
      const macId2 = userData.selectedMachineIds;
    try {
      const response = await axios.get(`/api/pump-data?userId=${userId}&macId=${macId2 || ''}`,
        { withCredentials: true }
      );
      setIngredients(response.data);
      setIngAll(response.data)
      setTotalRows(response.data.length);
      return response.data;
    } catch (error) {
      console.error('Error fetching pumps:', error);
    }
  };
  
const fetchIngredients = async (ingredientsData) => { 
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (!userData || !userData.id) {
      throw new Error('User ID not found in session storage');
      }
      const userId2 = userData.id;
      const macId2 = userData.selectedMachineIds;  
  try {
    const response = await axios.get(`/api/ingredients?userId=${userId2}&macId=${macId2}`,
      { withCredentials: true }
    );

    // Filter ingredients where stock_level_ml > 0
    const filteredData = response.data.filter(item => item.stock_level_ml > 0);

    setOptionsNames(filteredData);
  } catch (error) {
    console.error('Error fetching ingredients:', error);
  }
};
  const fetchData = async () => {
    const ingredientsData = await fetchPumps();
    if (ingredientsData) {
      await fetchIngredients(ingredientsData);
    }
  };
  
  useEffect(() => {
    // fetchIngredients();
    fetchData();
  }, [uId]);
  useEffect(() => {
    const fetchCurrentPumps = () => {
            fetchPumps();
    };
    fetchCurrentPumps();
    const intervalId = setInterval(fetchCurrentPumps, 15000);
    return () => clearInterval(intervalId);
  }, [uId]);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowIcon(e.target.value === '');
  };

  const handleEditClick = (ingredient) => {
    setEditForm(true);
    setEditId(ingredient.pump_no);
    setEPumpNo(ingredient.pump_no);
    setEPumpName(ingredient.ingredient_name);
    setEPumpCapacity(ingredient.capacity_ml);
    setEPumpLevel(ingredient.level_ml);
    setEPumpOffset(ingredient.offset);
    setNewPName(ingredient.ingredient_name);
    setTypeD(ingredient.type);
    fetchData();
  };
  
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalRows);
  const filteredIngredients = ingAll.filter((ingredient) =>
    ingredient.ingredient_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const currentIngredients = filteredIngredients.slice(startIndex, endIndex);
  // console.log(currentIngredients);
  const totalPages = Math.ceil(filteredIngredients.length / rowsPerPage);
  const pageButtons = [];
  for (let i = 1; i <= totalPages; i++) {
    pageButtons.push(
      <button
        key={i}
        onClick={() => setCurrentPage(i)}
        className={`pbtn ${currentPage === i && smallMedia ? "active12a2" : currentPage === i ? "active12" : ""}`}
      >
        {i}
      </button>
    );
  }
  const handleNoNew = (event) =>{
    setNewPNo(event.target.value);
  }
  const handleNameNew = (event) =>{
    setNewPName(event.target.value);
  }
  const handleCapacityNew = (event) =>{
  setNewPCapacity(event.target.value);
  }
  const handleLevelNew = (event) =>{
    setNewPLevel(event.target.value);
  }
  const handleOffsetNew = (event) =>{
    setNewPOffset(event.target.value);
  }
  const handleCapacityEdit = (event) =>{
    setEPumpCapacity(event.target.value);
  }
  const handleNameEdit = (event) =>{
    setEPumpName(event.target.value);
  }
  const handleLevelEdit = (event) =>{
  setEPumpLevel(event.target.value);
  }
  const handleOffsetEdit = (event) =>{
    setEPumpOffset(event.target.value);
    }
const handleNewSave = () => {
  alert("Can not add Pump")
};

  
  const handleCancelEdit = () => {
    setEditForm(false);
    setNewIngred(false);
    setNewPName('');
  };
  const handleSaveChanges = () => {
    if(ePumpName === '' || ePumpCapacity === '' || ePumpLevel === ''){
      alert('All fields are required!');
      return;
    }else if(ePumpLevel > ePumpCapacity ){
      alert('Level should not be greater then Capacity!');
      return;
    }else{
      
      fetch(`/api/updatePump/${editId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: selectedId,
          capacity: ePumpCapacity,
          level: ePumpLevel,
          offset: ePumpOffset,
          type: typeD,
          userId: uId,
          mId: macId
        }),
        credentials: 'include',
      })
      .then(response => response.json())  // Parse the response as JSON
      .then(data => {
        if (!data.message) {
          throw new Error(data.error || 'Failed to update Pump');
        }
        alert(data.message);
        fetchPumps();
        setEditForm(false);
      })
      .catch(error => {
        console.error('Error updating pump:', error.message);
        alert(error.message);  // Alert the error message
        // Handle error
      });
      setSelectedId(null);
      setNewPName('');
  }
  };
  const indexOfLastRecipe = currentPage * rowsPerPage;
const indexOfFirstRecipe = indexOfLastRecipe - rowsPerPage;
  const handleNextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousClick = () => {
    setCurrentPage(currentPage - 1);
  };
  const handleNameN = (selectedOption) => {
    // console.log(selectedOption,"This is selected option");
    
    setNewPName(selectedOption.name);
    const unId = selectedOption.unique_id.split("_");
    const id = unId[1];
    setSelectedId(id)
    setTypeD(selectedOption.type);
    
  };
  const getType = (data) =>{
    alert(data); 
  }
  const heightStyle = () => {
    const diff = Math.min(indexOfLastRecipe, filteredIngredients.length) - indexOfFirstRecipe;
    
    if (diff < 5) {
      return `${diff * 10}%`;  // First condition: when diff is less than 5
    } else if (diff < 10) {
      return `${diff * 8}%`;   // Second condition: when diff is less than 10
    } else {
      return '';               // Default case: no specific height applied
    }
  };


  
  const options = [
    {
      label: "Ingredients",
      options: optionsNames
        .filter(i => i.type === "ingredient")
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(i => ({
          value: i.name,
          label: i.name,
        })),
    },
    {
      label: "Juices",
      options: optionsNames
        .filter(i => i.type === "juice")
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(i => ({
          value: i.name,
          label: i.name,
        })),
    },
  ];
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      height: '100%',
      width: '100%',
      border: "none",
      color: "#EF7C32",
      boxShadow: "none",
      borderColor: "#EF7C32",
          "&:hover": {
        borderColor: "#EF7C32",
      },
    }),
  
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "#EF7C32",
      width: "1px",
    }),
  
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "#EF7C32",
      "&:hover": {
        color: "#EF7C32",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#EF7C32",
    }),
  
    input: (provided) => ({
      ...provided,
      color: "#EF7C32",
    }),
  
    placeholder: (provided) => ({
      ...provided,
      color: "#EF7C32",
    }),
  
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#BBBBBB",
    }),
  
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
        ? "#444"
        : "#2b2b2b",
      color: "black",
      backgroundColor: "#BBBBBB",
      cursor: "pointer",
    }),
  
    groupHeading: (provided) => ({
      ...provided,
      color: "#EF7C32",
      fontWeight: "bold",
      backgroundColor: "white",
      padding: "8px",
      textAlign: 'center'
    }),
  };


  return (
    <>
    <div className="sp-recipes">
      <div className="recipe-left" style={{display: smallMedia ? "none" : "block"}} ></div>
      <div className="full-details">
      {/* First div */}
      <div  className={` ${smallMedia ? "details2a" : "details2 topDiv"}`}>
      <div className={` same select-sp ${smallMedia ? "same2 display2" : ""}`}>
          Show
          <div className={`main-Select ${smallMedia ? "sub-class2 main-Select2" : ""}`}>
        <select value={rowsPerPage} onChange={handleRowsPerPageChange} className={`select-container ${smallMedia ? "select-container2" : ""}`}>
          {[5, 10, 15, 20, 25, 30].map((value) => (
            <option  className='options' key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        </div>
        Entries
          </div>
          <div className={` same ${smallMedia ? "same2" : ""}`}>
            <div className={` same ${smallMedia ? "search-container2" : "search-container"}`}>
              <div className={`${smallMedia ? "shadeTriangle-sea2" : "shadeTriangle-sea"}`}></div>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearch}
          className={` search-input ${smallMedia ? "search-input2" : ""}`}
        />
      <span className={` ${smallMedia ? "search-icon2" : "search-icon"}`} style={{ display: showIcon ? "block" : "none"}}>
      <SearchIcon className="sp-icon" />

        </span>
      </div>
        </div>
          <div className={` same btn-add ${smallMedia ? "same2" : ""}`}> 
            <button onClick={() => setNewIngred(true)} className='btnAdd'>
            <div className={` ${smallMedia ? "shadeTriangle-adbnt2" : "shadeTriangle-adbnt"}`}></div>
              <div className="btn-both">
                <div className='icon'>
                <Plus className="sp-icon"/>
                </div>
                <span className="add-text">Add New Pump</span>
              </div>
            </button>
          </div>
      </div>
      <div style={{display: editFrom ? "block" : "none"}}>
      <div className={`${smallMedia ? "popup2" : " popEI2 popup pop-pmp pmpNPopup"}`} >
        <div className='triangle-container-pop'>
          <div className={`${smallMedia ? "shadeTriangle-pop" : " shadeTriangle-pop2"}`}></div>
          </div>
          {/* Popup content for Edit pump */}
          <div className="form-pump promt">
            <h2 className='headIngre'>Edit Pump</h2>
            <div className="inpt-cont inpt-contE ">
              <label>Pump No</label>
              <div className={`inpt inpt-pmp ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={ePumpNo}
                  readOnly
                  className="pop-inpt"
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-contE">
              <label>Name:</label>
              <div className={`inpt inpt-pmp ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
                <div className="inptO"></div>
                <Select
                  options={options}
                  isSearchable
                  menuPlacement="auto"
                  placeholder="--Select Name--"
                  styles={customStyles}
                  className="choosen-prod choosen-pump-sp"
                  classNamePrefix="rs"
                  value={
                    newPName
                      ? {
                          value: newPName,
                          label: newPName,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    const selectedOption = optionsNames.find(
                      option => option.name === selected?.value
                    );

                    handleNameN(selectedOption);
                  }}
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-contE">
              <label>Capacity (ml)</label>
              <div className={`inpt inpt-pmp ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={ePumpCapacity}
                  onChange={handleCapacityEdit}
                  className="pop-inpt"
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-contE">
              <label>Level (ml)</label>
              <div className={`inpt inpt-pmp ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={ePumpLevel}
                  onChange={handleLevelEdit}
                  className="pop-inpt"
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-contE">
              <label>Rev/ml</label>
              <div className={`inpt inpt-pmp ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={ePumpOffset}
                  readOnly
                  className="pop-inpt"
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="pop-btn-sec pop-btn-secPE">
            <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
                  Close
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2"}`}>
                <button onClick={handleSaveChanges} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon">
                <SIcon className='sp-icon' />
              </div>
                <div>
                Save Change
                </div> 
                </button>
              </div>
          </div>
          </div>
        </div>
        </div>
        <div className={`${smallMedia ? "popup2" : " popEI2 popup pmpNPopup"}`} style={{display: newIngred ? "block" : "none"}}>
        <div className='triangle-container-pop'>
          <div className={`${smallMedia ? "shadeTriangle-pop" : " shadeTriangle-pop2"}`}></div>
          </div>
          {/* Popup content for adding new pump */}
          <div className="form-pump">
            <h2 className='headIngre'>Add New Pump</h2>
            <div className="inpt-cont inpt-cont-p">
              <label>Pump No</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={newPNo}
                  onChange={handleNoNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-cont-p">
              <label>Name:</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
              <Select
                options={options}
                isSearchable
                menuPlacement="auto"
                placeholder="--Select Name--"
                styles={customStyles}
                className="choosen-prod choosen-pump-sp"
                classNamePrefix="rs"
                value={
                  newPName
                    ? {
                        value: newPName,
                        label: newPName,
                      }
                    : null
                }
                onChange={(selected) => {
                  const selectedOption = optionsNames.find(
                    option => option.name === selected?.value
                  );

                  handleNameN(selectedOption);
                }}
              />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-cont-p">
              <label>Capacity (ml)</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={newPCapacity}
                  onChange={handleCapacityNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-cont-p">
              <label>Level (ml)</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={newPLevel}
                  onChange={handleLevelNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="pop-btn-sec pop-btn-secPN">
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
              <div>
              Close
              </div>
                  
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 "}`}>
                <button onClick={handleNewSave} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon-n">
                <SIcon className='sp-icon' />
              </div>
                <div>
                  Save
                </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      {/* Second div */}
      <div className="my-table" style={{ height: heightStyle(), overflow:'auto'}}>
        <table className="customTable sp-p-tbl" style={{borderCollapse: "separate", borderSpacing: "0 0.911vh" }} >
          <thead className="tb-head borderRow">
            <tr className="my-row">
            <th className='na-sp-t'>
              <div className='left-tr-name' style={{display : smallMedia ? 'none' : 'block'}}></div>
              <div className="nm-class">
              Pump#
              </div>
              </th>
              <th className="pmp-nme">Name</th>
              <th className="pmp-lvl">Level (ml)</th>
              <th className="pmp-cap">Capacity (ml)</th>
              <th className="pmp-ofst">Rev/ml</th>
              <th className="pmp-lstC">Last Cleaning</th>
              <th className='sp-td sp-tr spp'>
              <div className="ac-class">
              Action
              </div>
            <div className='right-tr-action' style={{display : smallMedia ? 'none' : 'block'}}></div>
               </th>
            </tr>
          
          </thead>
          <tbody>
            {(searchTerm === ''?currentIngredients:filteredIngredients).map((ingredient) => (
              <tr key={ingredient.id} className="custom-row">
              <td className="pmp-f-td na-sp-t-pmp">{ingredient.pump_no}</td>
                <td className="pmp-nme">{ingredient.ingredient_name}</td>
                <td className="pmp-lvl">{ingredient.level_ml}</td>
                <td className="pmp-cap">{ingredient.capacity_ml}</td>
                <td className="pmp-ofst">{ingredient.offset}</td>
                <td className="pmp-lstC">{ingredient.cl_date != null ? ingredient.cl_date.split('T')[0] : "Null"}</td>
                <td className="sp-pmp-ac">
                <div className="flex-container">
                <button onClick={() => handleEditClick(ingredient)} className={`editconst  ${smallMedia ? "editconst2" : "ed-sp sp-pmp"}`}>
                    <div className={` ${smallMedia ? "shadeTriangle-idbnt2" : "shadeTriangle-idbnt"}`}></div>
                    <div className="inE-icon icon22" style={{display : smallMedia ? 'none' : 'block'}}>
                  <Edit className='sp-icon' />
                  </div>
                  <div className="btnName">
                    Edit
                  </div>
                   
                </button>
                </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Third div */}
      <div className='bothDiv' >
      <div className='bottomSh'>
          <div className='results'>
            Showing {startIndex + 1} to {endIndex}
          </div>
          <div className='whiteClass'>
            (Total {totalRows} entries)
          </div>
        </div>
          
      <div className="pagination-info">
      <button onClick={handlePreviousClick} className='constbtn' disabled={currentPage === 1}>Previous</button>
        {pageButtons}
        <button onClick={handleNextClick} className='constbtn' disabled={currentPage === totalPages}>Next</button>
      </div>
      </div>
      </div>
    <div className="recipe-right" style={{display: smallMedia ? "none" : "block"}}></div>
    </div>
  </>
  );
};

export default PumpsTable;
